import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as fabricCanvasActions from '../../../redux/fabricCanvasActions';
import * as sideBarActions from '../../../redux/sideBarActions';
// import events from '../../../services/events';
import { string } from '../../../localization/Localization';
import * as Constants from '../../../utilities/constants/Constants';

const AI = props => {
  const { dispatchers } = props;

  const [aiImage, setAiImage] = useState();
  const [description, setDescription] = useState('');

  const aiImageObj = async url => {
    const { filename, size } = await fetchFileDetails(url);
    return {
      imagePath: url,
      userPhotoType: Constants.USER_PHOTO_SCENE_TYPE,
      fileName: filename,
      fileSize: size
    };
  };

  const addToCanvas = () => {
    dispatchers.sideBarActions.importFromOpenAI(aiImage);
  };

  const fetchAiImage = () => {
    dispatchers.fabricCanvasActions.setLoadingState(string.LOADING_KEY);
    dispatchers.sideBarActions
      .generateAI(description)
      .then(res => {
        console.log('res', res);
        aiImageObj(res.data.response[0].url).then(obj => {
          setAiImage(obj);
          dispatchers.fabricCanvasActions.setLoadingState(null);
        });
      })
      .catch(() => {
        dispatchers.fabricCanvasActions.setLoadingState(null);
      });
  };

  const fetchFileDetails = url =>
    new Promise(resolve => {
      const link = document.createElement('a');
      link.href = url;
      const filename = link.pathname.split('/').pop();
      const img = new Image();
      img.src = url;

      img.onload = () => {
        resolve({
          filename,
          size: parseInt(img.width * img.height, 10)
        });
      };
      img.onerror = () => {
        resolve({});
      };
    });

  const buttonStyle = {
    height: '50px',
    background: description == '' ? 'grey' : '#0096d6',
    color: 'white',
    font: '15px/20px HPSimplifiedLight, Arial, sans-serif',
    width: '100%'
  };

  return (
    <div className='p-3'>
      <div
        style={{
          color: 'white',
          font: '16px/21px HPSimplifiedLight, Arial, sans-serif !important'
        }}
        className='mb-2'
      >
        OPEN AI
      </div>

      {aiImage ? (
        <div>
          <div>
            <img
              alt=''
              src={aiImage.imagePath}
              className='mb-2'
              style={{ width: 200, height: 200 }}
              // {...(true
              //   ? {
              //       draggable: 'true',
              //       onDragStart: e => {
              //         events.onDragStart(
              //           e,
              //           aiImage,
              //           dispatchers.fabricCanvasActions.addToCanvas
              //         );
              //       },
              //       onDragEnd: e => {
              //         events.onDragEnd(e, aiImage);
              //       }
              //     }
              //   : {})}
            />{' '}
          </div>{' '}
          <button
            type='button'
            style={buttonStyle}
            className='mb-2'
            onClick={() => {
              addToCanvas();
            }}
          >
            Upload
          </button>
          <button
            style={buttonStyle}
            type='button'
            onClick={() => {
              setDescription('');
              setAiImage(null);
            }}
          >
            Generate again
          </button>
        </div>
      ) : (
        <div className='d-flex ' style={{ flexDirection: 'column' }}>
          <textarea
            value={description}
            onChange={e => {
              setDescription(e.target.value);
            }}
            placeholder='type here'
            rows='4'
            className='mb-2 p-2'
            style={{
              background: '#3c3c3c',
              borderRadius: '5px',
              color: 'white',
              outline: 'none'
            }}
          />
          <button
            type='button'
            disabled={description == ''}
            style={buttonStyle}
            onClick={() => {
              fetchAiImage();
            }}
          >
            Generate
          </button>
        </div>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    folderListElements: state.sideBar.folderListElements
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      sideBarActions: bindActionCreators(sideBarActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AI);
